import { project } from "@planzone/dto";
import { Id, Identifiable, Project } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { ProjectHistory } from "../../adapters/projectHistory";
import { Interactor } from "./types";

function limitHistory(history: Id[]): Id[] {
  return history.slice(0, 10);
}

function createInteractor(
  history: ProjectHistory,
  repository: Repository,
): Interactor {
  return () =>
    present(
      history
        .getHistory()
        .then(limitHistory)
        .then((projects) => projects.map(repository.getProject))
        .then((promises) => Promise.allSettled(promises))
        .then((promises) =>
          promises.filter(
            (promise) => promise.status === "fulfilled" && !!promise.value,
          ),
        )
        .then((promises) =>
          promises.map((promise) =>
            "value" in promise
              ? (promise.value as Identifiable<Project>)
              : project,
          ),
        ),
    );
}

export type { Interactor };

export { createInteractor };
